

// SCRIPTS

import { GeneralHomePage } from './home/home.page'; export { GeneralHomePage };
import { GeneralAboutPage } from './about/about.page'; export { GeneralAboutPage };
import { OptimizeNowFaq } from './optimizenow/optimizenow.faq'; export { OptimizeNowFaq };
import { OptimizeNowWho } from './optimizenow/optimizenow.who'; export { OptimizeNowWho };
import { OptimizeNowPage } from './optimizenow/optimizenow.page'; export { OptimizeNowPage };
import { OptimizeNowJoin } from './optimizenow/joinus.page'; export { OptimizeNowJoin };

// STYLES
import './home/home.scss';
import './about/about.scss';
import './resources/resources.scss';
import './links/links.scss';
import './optimizenow/optimizenow.scss';

$(() => {
    $('#studiesMenu').on('click', function () {
        $('#studiesDropdown').fadeToggle();
    });
});